import styled from 'styled-components';
import { marginProps } from './props';

export default styled.div`
  ${marginProps};
  cursor: pointer;
  font-weight: ${p => p.theme.fontWeight.bold};
  color: ${p => p.theme.colors.theme};
  transition: color 0.3s ease;
  &:hover {
    color: ${p => p.theme.colors.darkTheme};
  }
`;
